<template>
  <v-dialog
    v-model="show"
    max-width="400px"
    class="rounded-lg"
    style="z-index: 3"
    transition="scroll-y-reverse-transition"
    persistent
  >
    <v-card class="pa-0">
      <transition
        name="fade"
        mode="out-in"
        @before-leave="beforeLeave"
        @enter="enter"
        @after-enter="afterEnter"
      >
        <component
          :is="component"
          v-bind="componentProps"
          @triggerPopup="triggerOpenAccountFromMenu"
          @close="onCloseDialog"
        />
      </transition>
    </v-card>
  </v-dialog>
</template>

<script>
import Login from './AccountLogin.vue';
import Register from './AccountRegister.vue';
import RegisterSuccess from './AccountRegisterSuccess.vue';
import Activate from './AccountActivation.vue';
import ResetPassword from './AccountResetPassword.vue';
import ResetPasswordSuccess from './AccountResetPasswordSuccess.vue';
import RedirectToPartner from './RedirectToPartner.vue';
import Unsubscribe from './AccountUnsubscribe.vue';
import AccountResendActivationSuccess from './AccountResendActivationSuccess.vue';
import ChangePassword from './AccountChangePassword.vue';
import ConfirmEmailChange from './AccountConfirmEmailChange.vue';
import ConfirmUserRelationAsChild from './ConfirmUserRelationAsChild.vue';

export default {
  name: 'Account',
  components: {
    Login,
    Register,
    RegisterSuccess,
    Activate,
    ResetPassword,
    ResetPasswordSuccess,
    RedirectToPartner,
    Unsubscribe,
    AccountResendActivationSuccess,
    ChangePassword,
    ConfirmEmailChange,
    ConfirmUserRelationAsChild,
  },
  data() {
    return {
      show: false,
      component: 'Login',
      componentProps: {},

      prevHeight: 0,
    };
  },
  created() {
    /*
     * Registering listeners
     */
    window.EventBus.listen(
      'triggerOpenAccountFromMenu',
      this.triggerOpenAccountFromMenu
    );
  },
  beforeDestroy() {
    /*
     * Unregistering listeners
     */
    window.EventBus.removeListener('triggerOpenAccountFromMenu');
  },
  mounted() {},
  methods: {
    triggerOpenAccountFromMenu(args) {
      if (args.product)
        this.$store.commit('event/setCurrentWatchedProduct', args.product);
      // Triggers the Account dialog to be opened or closed
      this.show = args.toggle;
      this.component = args.component;
      if (args.props != null) {
        this.componentProps = args.props;
      }
    },
    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height;
    },
    enter(element) {
      const { height } = getComputedStyle(element);

      element.style.height = this.prevHeight;

      setTimeout(() => {
        element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = 'auto';
    },
    onCloseDialog() {
      if (this.component === 'ChangePassword') {
        // Reset url to home page if it's ChangePassword
        this.$router.push({
          name: 'Homepage',
          params: {
            account_id: this.$store.getters.getRegion,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.2s;
  transition-property: height, opacity;
  transition-timing-function: ease;
  overflow: hidden;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
